import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const STUDENT_PORTAL_PRESET = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#EFF6FF',
      100: '#DBEAFE',
      200: '#BFDBFE',
      300: '#93C5FD',
      400: '#60A5FA',
      500: '#005BAC',
      600: '#004C90',
      700: '#003C73',
      800: '#002D56',
      900: '#001D39',
      950: '#00101F',
    },
    focusRing: {
      width: '2px',
      style: 'solid',
      color: '{primary.color}',
      offset: '2px',
    },
  },
  components: {
    inputtext: {
      root: {
        lg: {
          fontSize: '14px ',
        },
      },
    },
    datatable: {
      css: `
      .p-datatable-tbody > tr > td {
        text-align: center;
        font-size: 14px;
      }
      .p-datatable-thead > tr > th {
        text-align: center;
      } 
      `,
    },
  },
});
